const $ = jQuery.noConflict();

var $window = $(window);
let scrollTop;

export function scrollTo(location, scrollTime=0){
   var offset = parseInt(location);
   if (!scrollTime){
      $('html, body').scrollTop(location);
   }
   else{
      $('html, body').animate({
         'scrollTop': offset + 'px',
      }, scrollTime);
   }
}

let affixes = function () {
   var startPosition, startHeight;
   var $affixes = $('.evtx-affixed');
   if ($affixes.length) {
      startPosition = $affixes.offset().top;
      startHeight = $affixes.outerHeight();
      startPosition -= startHeight;
   }
   
   return function () {
      if ($affixes.length) {
         if (scrollTop - (startPosition - startHeight)
            > $affixes.outerHeight()) {
            if (!$affixes.hasClass('top-fixed')) {
               startPosition = $affixes.offset().top;
               startHeight = $affixes.outerHeight();
               $affixes.addClass("top-fixed");
               // $affixes.css('height', startHeight + 'px');
               $affixes
                  .closest('.evtx-module-scope')
                  .css('min-height', startHeight + 'px');
            }
         }
         else {
            if ($affixes.hasClass('top-fixed')) {
               $affixes
                  .removeClass('top-fixed')
                  .removeClass('open')
                  .closest('.evtx-module-scope')
                  .css('min-height', startHeight + 'px');
            }
         }
      }
   };
};
export function setupScrollEvents(){
   $(document).ready(function(){
      // initialize parallax objects
      window.evtxLaxObjs = [];
      if (typeof evtxLaxIds !== "undefined"){
         for (var i = 0; i < evtxLaxIds.length; i++){
            var $moduleObj = $('#' + evtxLaxIds[i]);
            var $laxObj = $moduleObj.find('.lax');
            
            $laxObj.each(function(){
               var $this = $(this);
               $this.css('will-change', 'transform');
               var $infoObj = $moduleObj.find('.evtx-info-wrapper');
               // if ($moduleObj.length && $laxObj.length){
               
               if ($moduleObj.length){
                  evtxLaxObjs.push({
                     $module: $moduleObj,
                     $lax: $(this),
                     $info: $infoObj,
                  });
               }
            });
         
         }
      }
      affixes = affixes();
      runParallax();

      $window
         .scroll(onScroll)
         .resize(screenChange)
         .load(screenChange);
		
      screenChange();
   });
}
   
export function screenChange() {
   scrollTop = $window.scrollTop();
   window.pageContentHeight = $('.evtx-page-content').height();
   if (evtxLaxObjs) {
      evtxLaxObjs = evtxLaxObjs.map(lax => {
         return {
            ...lax,
            moduleHeight: lax.$module.height(),
            laxAmount: getLaxAmount(lax),
         };
      });
   }

   window.requestAnimationFrame(function () {
      runParallax();
      affixes();
   });
}

export function onScroll(){
   scrollTop = $window.scrollTop();
   window.requestAnimationFrame(function () {
      runParallax();
      affixes();
   });
}

export function getLaxAmount(laxObj){
   var laxAmount;
   if (laxObj.$lax.attr('data-lax-amount')) {
      laxAmount = laxObj.$lax.attr('data-lax-amount');
      if (laxAmount.toString().toLowerCase() == "content") {
         laxAmount = window.pageContentHeight - laxObj.$lax.height();
      }
      else {
         laxAmount = parseInt(laxAmount);
      }
   }
   else {
      laxAmount = (laxObj.$lax.height() - laxObj.$module.height()) / 2;
   }
   return laxAmount;
}

// Move parallax objects on scroll
export function runParallax(){
   evtxLaxObjs.forEach(lax => {
      var percThru = scrollTop / lax.moduleHeight;
      if (lax.$lax.length){
         var translateCss = 'translateY(' + percThru * lax.laxAmount + 'px)';
         lax.$lax.css('transform', translateCss);
      }
      if (lax.$info.length){
         translateCss = 'translateY(-' + percThru * (lax.laxAmount/2) + 'px)';
         lax.$info.css('transform', translateCss);
      }
   });
}


/**
 * Checks for fixed position menus and returns the distance
 * to the readable portion of the document.
 * Useful for searching/scrolling operations.
 * @return {integer} Distance from top of browser to readable portion.
 */
export function contentOffset(){
   var offset = 0;
   var $fixedMenu = jQuery('#evtx-modules.top-fixed');
   if ($fixedMenu.length){
	    offset += parseInt($fixedMenu.outerHeight());
	    var paddingBottom = window
	        .getComputedStyle($fixedMenu.get(0), null)
	        .getPropertyValue('padding-bottom');
	    offset += parseInt(paddingBottom);
   }
   return offset;
}